import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import portalApi, { clearPortalToken } from '../../portalApi';
import { useLang } from '../../context/LangContext';

export default function PortalHomePage() {
  const { t, lang, switchLang } = useLang();
  const [reports, setReports] = useState(null);
  const [error, setError]     = useState('');

  useEffect(() => {
    if (!localStorage.getItem('portal_token')) { setError('no_session'); return; }
    portalApi.get('/api/portal/reports')
      .then(r => setReports(r.data))
      .catch(() => setError('no_session'));
  }, []);

  function handleLogout() {
    clearPortalToken();
    setReports(null);
    setError('no_session');
  }

  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: '24px 16px' }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src="/logo-fdconsult.png" alt="FDConsult" style={{ height: 40 }} />
        <div className="d-flex align-items-center gap-3">
          {reports && (
            <button className="btn btn-link btn-sm p-0 text-muted" onClick={handleLogout}>{t('nav_logout')}</button>
          )}
          <div className="lang-toggle">
            <button className={lang === 'nl' ? 'active' : ''} onClick={() => switchLang('nl')}>NL</button>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')}>EN</button>
          </div>
        </div>
      </div>

      <h4 className="mb-3">{t('portal_home_title')}</h4>

      {error === 'no_session' ? (
        <div className="alert alert-info">{t('portal_no_session')}</div>
      ) : reports === null ? (
        <div className="text-center text-muted py-5"><span className="spinner-border spinner-border-sm me-2" />{t('loading')}</div>
      ) : reports.length === 0 ? (
        <div className="text-muted">{t('portal_home_none')}</div>
      ) : (
        <div className="list-group">
          {reports.map(r => (
            <Link key={r.id} to={`/portal/report/${r.id}`} className="list-group-item list-group-item-action">
              <div className="fw-semibold">{r.audit_name}</div>
              <div className="small text-muted">
                {r.client_name}{r.audit_date ? ` · ${new Date(r.audit_date).toLocaleDateString()}` : ''}
                {r.expires_at ? ` · ${t('portal_expires')} ${new Date(r.expires_at).toLocaleDateString()}` : ''}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
